<template>
    <div class="show-modal-wrapper">
        <div v-if="isLoading" class="text-center py-5">
            <b-spinner variant="primary"></b-spinner>
        </div>
        <b-card v-else no-body>
            <b-tabs card>
                <b-tab :title="$t('personal_information')" active>
                    <b-row>
                        <b-col md="6">
                            <table class="table table-sm table-striped border rounded">
                                <tbody>
                                    <tr><th>{{ $t('national_id') }}</th><td>{{ detail.national_id }}</td></tr>
                                    <tr><th>{{ $t('name') }}</th><td>{{ detail.name }}</td></tr>
                                    <tr><th>{{ $t('surname') }}</th><td>{{ detail.surname }}</td></tr>
                                    <tr><th>{{ $t('date_of_birth') }}</th><td>{{ detail.birthdate }}</td></tr>
                                    <tr><th>{{ $t('gender') }}</th><td>{{ detail.gender }}</td></tr>
                                    <tr><th>{{ $t('father_name') }}</th><td>{{ detail.father_name }}</td></tr>
                                    <tr><th>{{ $t('mother_name') }}</th><td>{{ detail.mother_name }}</td></tr>
                                    <tr><th>{{ $t('nationality') }}</th><td>{{ detail.nationality_code }}</td></tr>
                                </tbody>
                            </table>
                        </b-col>
                        <b-col md="6">
                            <table class="table table-sm table-striped border rounded">
                                <tbody>
                                    <tr><th>{{ $t('address') }}</th><td>{{ detail.address }}</td></tr>
                                    <tr><th>{{ $t('email') }}</th><td>{{ detail.email }}</td></tr>
                                    <tr><th>{{ $t('telephone') }}</th><td>{{ detail.phone }}</td></tr>
                                    <tr><th>{{ $t('university') }}</th><td>{{ detail.last_school }}</td></tr>
                                </tbody>
                            </table>
                        </b-col>
                    </b-row>
                </b-tab>

                <b-tab :title="$t('program_information')">
                    <b-row>
                        <b-col md="12">
                            <table class="table table-sm table-striped border rounded">
                                <tbody>
                                    <tr><th width="20%">{{ $t('academic_year') }}</th><td>{{ detail.academic_year }}</td></tr>
                                    <tr><th>{{ $t('program') }}</th><td>{{ detail.program }} - {{ getLocaleText(detail, 'program_name') }}</td></tr>
                                    <tr><th>{{ $t('with_without_thesis') }}</th><td>{{ detail.thesis_type || 'N/A' }}</td></tr>
                                    <tr><th>{{ $t('level') }}</th><td>{{ detail.isGraduate ? $t('graduate_level_text') : $t('undergraduate_level_text') }}</td></tr>
                                </tbody>
                            </table>
                        </b-col>
                    </b-row>
                </b-tab>

                <b-tab :title="$t('course_registration')">
                    <b-table
                        striped hover small borderless
                        :items="detail.courses"
                        :fields="courseFields"
                    ></b-table>
                </b-tab>

                <b-tab :title="$t('documents')">
                    <b-table
                        striped hover small borderless
                        :items="detail.documents"
                        :fields="documentFields"
                    >
                        <template v-slot:cell(actions)="data">
                            <b-button size="sm" variant="link" @click="download(data.item)">
                                <i class="ri-download-line"></i>
                            </b-button>
                        </template>
                    </b-table>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
import VisitorStudentApplicationService from "@/services/VisitorStudentApplicationServices";

export default {
    name: "ShowModal",
    props: {
        applicationId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            isLoading: false,
            detail: {},
            courseFields: [
                { key: 'course_code', label: this.$t('course_code') },
                { key: 'course_name', label: this.$t('course_name') },
                { key: this.getLocaleField('course_type_name'), label: this.$t('course_type_name') },
                { key: 'section', label: 'Section' },
                { key: 'credit', label: this.$t('credit') }
            ],
            documentFields: [
                { key: this.getLocaleField('document_type_name'), label: this.$t('document_name') },
                { key: 'status', label: this.$t('status') },
                { key: 'reason', label: this.$t('reason') },
                { key: 'actions', label: this.$t('download'), class: 'd-flex justify-content-end' },
            ]
        }
    },
    mounted() {
        this.get();
    },
    methods: {
        get() {
            this.isLoading = true;
            VisitorStudentApplicationService.get(this.applicationId)
                .then(response => {
                    this.detail = response.data.data;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        download(row) {
            let formData = {
                document_type: row.document_type
            }
            VisitorStudentApplicationService.download(this.detail.id, formData)
                .then(response=>{
                    this._downloadFile(response, row.file_name)
                }).catch(e => {
                this.showErrors(e, null, true)
            })
        }
    }
}
</script>

<style scoped>
.table th {
    background-color: #f1f3f5;
}
</style>
